<template>
  <div>
    <div class="search-box">
      <a-space>
        <a-select
          mode="tags"
          style="width:auto;min-width:120px"
          placeholder="选择班级"
          v-model="classId"
          @change="handleChangeClass"
        >
          <a-select-option
            v-for="(item, index) in classList"
            :key="index"
            :value="item.id"
            >{{ item.class_name }}</a-select-option
          >
        </a-select>

        <a-input v-model="form.keyword" placeholder="输入老师姓名"></a-input>
        <!--时间段筛选-->
        <!-- <a-range-picker
          style="width: 240px;"
          v-model="searchDate"
          @change="changeDateTime"
          show-time
        >
          <a-icon slot="suffixIcon" type="carry-out" />
        </a-range-picker> -->
        <!--搜索按钮-->
        <a-button shape="round" type="primary" @click="handleSearch">
          搜索
        </a-button>
        <!--重置按钮-->
        <a-button shape="round" type="default" round @click="reset">
          重置
        </a-button>
      </a-space>

      <!--导出数据表按钮-->
      <a-button shape="round" type="primary" style="float: right" @click="exportTable">
        导出数据表
      </a-button>
    </div>
    <!--表格-->
    <div style="background: #fff;">
      <a-table
      ref="table"
            :columns="columns"
            :data-source="data"
            :pagination="false"
            :row-key="(record, index) => index"
          >
          </a-table>
    </div>

    <!--分页-->
    <div style="margin-top: 20px;text-align:center">
      <a-pagination
        :total="total"
        :page-size="form.pageSize"
        v-model="form.currentPage"
        show-quick-jumper
        @change="pageChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { reportApi, leaderApi } from '../../../api/api-director';
import axios from 'axios';
import qs from 'qs';
import * as XLSX from 'xlsx'

export default {
  name: "reportClass",
  data() {
    return {
      msg: "Hello World!",
      pickerOptions: {},
      columns: [
        {
          title: "教师姓名",
          key: "teacher_name",
          dataIndex: "teacher_name",
          scopedSlots: { customRender: "teacher_name" },
          align: "center",
        },
        {
          title: "总记录数",
          key: "total_count",
          dataIndex: "total_count",
          scopedSlots: { customRender: "total_count" },
          align: "center",
        },
        {
          title: "快速记数",
          dataIndex: "total_notable",
          key: "total_notable",
          align: "center",
        },
        {
          title: "观察记录表数",
          dataIndex: "total_record",
          key: "total_record",
          align: "center",
        },
        {
          title: "同步家长记录数",
          key: "total_sync",
          dataIndex: "total_sync",
          align: "center",
        },
      ],
      search: "", // 搜索关键字
      searchDate: null, // 时间段
      data: [], // 表格数据
      classList: [], // 班级列表
      total: 0,
      form: {
        class_id: "", // 班级id
        pageSize: 10, 
        currentPage: 1, 
        school_id: "", // 学校id
        // semester_id: "",
        // testfield_id:""
      },
      classId: [], // 班级id数组
      resetForm: { // 重置表单
        class_id: "", // 班级id
        pageSize: 10,
        currentPage: 1,
        school_id: "", // 学校id
      }
    };
  },
  created() {
    if (this.school && this.school.id) { // 判断是否有学校id
      this.form.school_id = this.school.id; // 设置学校id
      this.resetForm.school_id = this.school.id; // 设置学校id
      this.getList(); // 获取表格数据
      this.getSemesterList(); // 获取学期列表
    }
  },
  computed: {
    ...mapState(["headers", "userInfo", "school"]),
  },
  watch: {
    school(newVal, oldVal) {
      this.form.school_id = newVal.id; // 设置学校id
      this.resetForm.school_id = newVal.id; // 设置学校id
      this.getSemesterList();
    }
  },
  methods: {
    getSemesterList() {
      this.$axios({
        method: "post",
        url: reportApi.main + reportApi.getSemesterList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          currentPage: 1,
          pageSize: 100,
        }),
      }).then((res) => {
        if (res.data.result) {
          this.currentSemester = res.data.data[0];
          this.form.semester_id = this.currentSemester.sm_id
          this.getClassList();
          this.getList(); // 获取表格数据
        }
      });
    },
    handleChangeClass(value) {
      console.log(value)
      this.form.class_id = value.join(','); // 设置班级id
    },
    pageChange() {
      this.getList(); // 获取表格数据
    },
    getClassList() {
      const form = {
        currentPage: 1,
        pageSize: 100,
        leader_id: this.userInfo.id,
        sid: this.$store.state.headers,
        school_id: this.school.id || "",
        semester_id: this.form.semester_id || "",
      };
      axios({
        method: "post",
        url: leaderApi.main + leaderApi.allClassList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify(form),
      }).then((res) => {
        this.classList = res.data.data;
      });
    },
    exportTable() {
      
      const table = this.$refs.table; // 获取表格实例
      const data = table.dataSource; // 获取表格数据
      //按columns将data数据的键名改成中文的
      const table_to_cz = []

      data.forEach((arr,index)=> {
        table_to_cz.push({})
        this.columns.forEach(item => {
          table_to_cz[index][item.title] = arr[item.key]
        })
      })

      const workbook = XLSX.utils.book_new(); // 创建工作簿
      const worksheet = XLSX.utils.json_to_sheet(table_to_cz); // 将数据转换为工作表
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1"); // 将工作表添加到工作簿中
      XLSX.writeFile(workbook, "table.xlsx"); // 导出文件
      this.$message.success("导出成功"); // 提示导出成功
      console.log("导出数据表");
    },
    getList() {
      this.$axios({
        method: "POST",
        url: reportApi.main + reportApi.getTeacherStatisList,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify(this.form),
      }).then(res => {
          if (res.data.result) { 
            this.data = res.data.data.map(item => {
              return {
                ...item,
              }
            })
            this.total = res.data.pager.totalCount
          } else {
            this.data = []
            this.total = 0
          }
      })
    },
    handleSearch() {
      this.form.currentPage = 1; // 重置当前页为1
      this.getList(); // 调用获取表格数据的方法
    },
    reset() {
      this.form = { ...this.resetForm }; // 重置表单
      this.classId = []; // 重置班级id数组
    },
    // changeDateTime(e, time) {
    //   this.observeListForm.stime = time[0];
    //   this.observeListForm.etime = time[1];
    // },
  },
};
</script>

<style lang="less" scoped>
.search-box {
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}
</style>
